export default "__VITE_ASSET__ZP5a0XZW__"